import { http, IHttpErrorResponse } from "../http";
import { IRepoErrors } from "../errors";

export class SyncRevelMenuError extends Error {
  errors: IRepoErrors;

  constructor(errors: IRepoErrors) {
    super("Error in repo: SyncRevelMenu");
    this.errors = errors;
    this.name = this.constructor.name;
  }
}

export async function syncRevelMenu(request: {
  businessId: string;
}): Promise<void> {
  try {
    await http.post(`revel/businesses/${request.businessId}/push-menu`);
  } catch (e: any) {
    const error: IRepoErrors<null> = {};
    const isAxiosError = Boolean(e?.isAxiosError);

    if (!isAxiosError) {
      throw e;
    }

    const response: IHttpErrorResponse = e.response || {};

    if (response.status === 429) {
      return;
    }

    throw new SyncRevelMenuError(error);
  }
}
